import { Pipe, PipeTransform } from '@angular/core';
import { formatDuration } from 'src/app/functions/time-formatter.function';

@Pipe({
  name: 'timeDuration',
  pure: false,
})
export class TimeDurationFormatterPipe implements PipeTransform {

  transform(value: number, ...args: any[]): any {
    if (!value || value === null || value === undefined || value === 0 || isNaN(value)) return '-';
    return formatDuration(value);
  }

}
